<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    filled
    dense
  ></v-select>
</template>

<script>
  import RefreshOnDemand from '@/components/codelist/mixins/RefreshOnDemand'
  import UserGroupService from '@/services/user-group'

  export default {
    name: 'UserGroup',
    mixins: [
      RefreshOnDemand,
    ],
    data: () => ({
    }),
    computed: {
      key () {
        return 'user_groups1'
      },
    },
    methods: {
      fetchData () {
        const us = new UserGroupService()
        us.list().then((response) => {
          const newItems = [{
            text: '-----',
            value: -1,
          }]
          for (const item of response.data.data) {
            newItems.push({
              text: item.name,
              value: item.id,
            })
          }
          this.$store.commit('codeList/updateCache', { key: this.key, value: newItems })
        })
      },
    },
  }
</script>

<style scoped>

</style>
